import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { SET_PRIVACY_POLICY_DIALOGUE_OPEN } from '../actions/types';
import PopupWindow from './PopupWindow';

const PrivacyPolicyDialogue = ({ siteboardAction }) => {
  const sectionHeaderStyle = 'font-bold mt-6';
  const listItemStyle = '';
  const closeDialogue = () => {
    siteboardAction(SET_PRIVACY_POLICY_DIALOGUE_OPEN, { isOpen: false });
  };

  return (
    <PopupWindow title={`Privacy Policy`} closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='text-[1.2em] text-white max-w-screen-lg'>
        <div className=''>Effective Date: January 21, 2025</div>

        <div className={sectionHeaderStyle}>Introduction  </div>
        Welcome to {process.env.REACT_APP_WEBSITE_NAME}! We respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website and use our services.  

        <div className={sectionHeaderStyle}>1. Information We Collect  </div>
        We may collect the following types of information:  
        <div className={listItemStyle}>- Personal Information: Name, email address, phone number, or any other information you voluntarily provide when contacting us or creating an account.  </div>
        <div className={listItemStyle}>- Non-Personal Information: Information about your interaction with our website, such as IP address, browser type, and device information.  </div>

        <div className={sectionHeaderStyle}>2. How We Use Your Information  </div>
        We use the information we collect to:  
        <div className={listItemStyle}>- Provide and improve our services.  </div>
        <div className={listItemStyle}>- Respond to inquiries and customer support requests.  </div>
        <div className={listItemStyle}>- Send important updates, newsletters, or promotional materials (you may opt out at any time).  </div>
        <div className={listItemStyle}>- Analyze website usage to improve user experience.  </div>

        <div className={sectionHeaderStyle}>3. How We Share Your Information  </div>
        We do not sell, rent, or trade your personal information. We may share your information in the following circumstances:  
        <div className={listItemStyle}>- Service Providers: With trusted third-party vendors who assist us in delivering our services. These currently include Amazon Web Services and Stripe.</div>
        <div className={listItemStyle}>- Legal Obligations: When required to comply with legal obligations or protect our rights.  </div>
        <div className={listItemStyle}>- Business Transfers: In connection with a merger, sale, or acquisition of our business.  </div>

        <div className={sectionHeaderStyle}>4. Data Retention  </div>
        We retain your personal information only as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.  

        <div className={sectionHeaderStyle}>5. Cookies and Tracking Technologies  </div>
        Our website uses cookies and similar technologies to enhance user experience and analyze site performance. You can manage your cookie preferences through your browser settings.  

        <div className={sectionHeaderStyle}>6. Data Security  </div>
        We implement industry-standard security measures to protect your information. However, no system is entirely secure, and we cannot guarantee the absolute security of your data.  

        <div className={sectionHeaderStyle}>7. Your Rights  </div>
        Depending on your location, you may have the following rights regarding your personal information:  
        <div className={listItemStyle}>- Access your data and request corrections.  </div>
        <div className={listItemStyle}>- Request deletion of your data.  </div>
        <div className={listItemStyle}>- Opt out of marketing communications.  </div>
        To exercise these rights, please contact us at:
        <div className='font-bold'>{process.env.REACT_APP_SUPPORT_EMAIL}</div>

        <div className={sectionHeaderStyle}>8. Third-Party Links  </div>
        Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of these external websites.  

        <div className={sectionHeaderStyle}>9. Updates to This Privacy Policy  </div>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised effective date.  

        <div className={sectionHeaderStyle}>10. Contact Us  </div>
        If you have any questions or concerns about this Privacy Policy, please contact us at:  
        <div className='font-bold'>{process.env.REACT_APP_SUPPORT_EMAIL}</div>

        <div className={sectionHeaderStyle}>Thank you for trusting {process.env.REACT_APP_WEBSITE_NAME}</div>
      </div>
    </PopupWindow>
 );
};

const mapStateToProps = state => { return {}};
export default connect(mapStateToProps, { siteboardAction })(PrivacyPolicyDialogue);
